<template lang="html">
<div>

    <v-container>
      <v-layout row wrap align-space-around justify-center fill-height>
        <v-flex  md12 v-for="card in cards">
          <v-container>
          <v-card elevation="6" color="grey lighten-2">
              <v-img
                :src="card.image"
                aspect-ratio="5"
              ></v-img>

              <v-card-title primary-title>
                <h1 class="headline mb-12" v-html="card.title"></h1>
                </v-card-title>

                <v-card-text>
                <h2 align-center v-html="card.text"></h2>
              </v-card-text>

            </v-card>
          </v-container>
          </v-flex>
      </v-layout>
    </v-container>
</div>
</template>

<script>
export default {
  data() {
    return {
      cards: [{
        image: require('../../public/img/Images reseaux sociaux gif.png'),
        title: this.$t('parallax.element1.TITLE'),
        text: this.$t('parallax.element1.TEXT')
      }]
    }
  }
}
</script>

<style lang="css" scoped>
</style>
